import { useCallback, useMemo } from "react";

import { isApiError } from "../../api/common";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorageKeys";
import {
    composeErrorHandlers,
    ErrorHandler,
    ErrorHandlerCreator,
} from "../../utils/errorHandling";

import useLocalStorage from "./useLocalStorage";
import useLogout from "./useLogout";

export enum AuthError {
    EXPIRY = "EXPIRY",
}

export const useAuthErrorHandlerCreator = (): ErrorHandlerCreator => {
    const logout = useLogout();
    const [, setAuthError] = useLocalStorage(LOCAL_STORAGE_KEY.AUTH_ERROR);

    return useCallback(
        (next) => {
            return (error) => {
                if (isApiError(error)) {
                    if (error.status === 403) {
                        setAuthError(AuthError.EXPIRY);
                        logout();
                    } else {
                        next(error);
                    }
                } else {
                    next(error);
                }
            };
        },
        [setAuthError, logout],
    );
};

const useAuthErrorHandler = (): ErrorHandler => {
    const onAuthErrorHandler = useAuthErrorHandlerCreator();
    return useMemo(
        () => composeErrorHandlers(onAuthErrorHandler),
        [onAuthErrorHandler],
    );
};

export default useAuthErrorHandler;
